export default {
  'imm0008.whereDoYouPlanToLive': '您打算在加拿大哪里定居？',
  'imm0008.provinceTerritory': '省/地区',
  'imm0008.cityTown': '城市/镇',
  'imm0008.fullName': '姓名',
  'imm0008.otherNames': '您是否曾用其他姓名（如昵称、婚前姓名、别名等）？',
  'imm0008.yesUsedOtherName': '如果是，请提供您曾使用的姓名',

  'imm0008.physicalCharacteristics': '身体特征',
  'imm0008.sex': '性别',
  'imm0008.eyeColour': '眼睛颜色',
  'imm0008.height': '身高（厘米）',

  'imm0008.birthInformation': '出生信息',
  'imm0008.dateOfBirth': '出生日期（年/月/日）',
  'imm0008.cityOfBirth': '出生城市',
  'imm0008.countryOfBirth': '出生国家',

  'imm0008.citizenship': '国籍',
  'imm0008.citizenship1': '第一国籍',
  'imm0008.citizenship2': '第二国籍（如果适用）',

  'imm0008.currentCountryOfResidence': '当前居住国',
  'imm0008.currentResidenceCountry': '国家',
  'imm0008.currentResidenceStatus':
    '居住状态（例如公民、永久居民、工人、学生、游客等）',
  'imm0008.currentResidenceVisaIssueDate':
    '签证签发日期（年/月/日）（如果适用）',
  'imm0008.currentResidenceVisaExpiryDate':
    '签证过期日期（年/月/日）（如果适用）',

  'imm0008.lastEntryToCanada':
    '如果您的当前居住国是加拿大，请提供您最近一次入境加拿大的日期和地点',
  'imm0008.lastEntryDate': '日期（年/月/日）',
  'imm0008.lastEntryPlace': '地点',

  'imm0008.previousCountriesResidence': '之前居住的国家',
  'imm0008.hasPreviousCountries':
    '在过去五年中，除了您的国籍国或当前居住国（以上所述）外，您是否在任何其他国家居住超过六个月？',

  'imm0008.previousCountriesTitle': '如果您的回答是“是”，请提供详细信息。',
  'imm0008.previousCountryTitle': '之前居住的国家 #',
  'imm0008.previousCountryCountry': '国家',
  'imm0008.previousCountryImmigrationStatus':
    '移民状态（例如公民、永久居民、工人、学生、游客等）',
  'imm0008.previousCountryImmigrationStartDate': '移民状态开始日期（年/月/日）',
  'imm0008.previousCountryImmigrationEndDate': '移民状态结束日期（年/月/日）',

  'imm0008.maritalStatusTitle': '婚姻和关系状况',
  'imm0008.currentMaritalStatus':
    '当前婚姻状况（例如已婚、同居、单身、离婚、丧偶等）',
  'imm0008.marriageOrCommonLawDate':
    '（如果已婚或有同居关系）请提供您结婚或开始同居关系的日期。日期（年/月/日）',
  'imm0008.fullNameOfSpouse': '您当前/配偶/同居伴侣的全名（如果适用）',

  'imm0008.previousMarriageOrCommonLawTitle': '之前婚姻或同居关系',
  'imm0008.previouslyMarriedOrCommonLaw': '您之前是否结过婚或有过同居关系？',
  'imm0008.previousSpouseDetailsTitle':
    '如果之前结过婚或有过同居关系，请提供您之前配偶/同居伴侣的详细信息',
  'imm0008.previousSpouseFullName': '您之前配偶/同居伴侣的全名',
  'imm0008.previousSpouseDob': '您之前配偶/同居伴侣的出生日期（年/月/日）',
  'imm0008.typeOfRelationship': '关系类型（已婚或同居）',
  'imm0008.relationshipStartDate': '关系开始日期（年/月/日）',
  'imm0008.relationshipEndDate': '关系结束日期（年/月/日）',

  'imm0008.passportNumber':
    '护照/旅行文件号码（与您护照或旅行文件上的号码完全一致）',
  'imm0008.passportCountry':
    '签发国/国家代码（与您护照或旅行文件上的国家代码完全一致）',
  'imm0008.passportIssueDate': '签发日期（年/月/日）',
  'imm0008.passportExpiryDate': '过期日期（年/月/日）',

  'imm0008.nationalIdDocumentNumber': '身份证号码/国家身份证明号码',
  'imm0008.nationalIdCountry': '签发国/国家代码',
  'imm0008.nationalIdIssueDate': '签发日期（年/月/日）',
  'imm0008.nationalIdExpiryDate': '过期日期（年/月/日）',

  'imm0008.educationInfoTitle': '教育信息',
  'imm0008.highestEducation': '最高教育水平',
  'imm0008.educationYears': '教育年限',
  'imm0008.occupationInfoTitle': '职业信息',
  'imm0008.currentOccupation':
    '目前职业（如果您的被抚养人没有工作，请输入"未就业"）',
  'imm0008.intendedOccupation':
    '计划从事的职业（如果您的被抚养人不打算在加拿大工作（例如，如果他们未到工作年龄），请输入"无"）',

  'imm0008.communicateInEnglishFrench':
    '您能用英语和/或法语交流吗？（请选择英语、法语或两者或两者都不）',
  'imm0008.takenLanguageTest': '您是否参加过英语或法语水平测试？',

  'imm0008.dependantTableTitle': '其他家庭成员',
  'imm0008.dependantTableFullName': '姓名',
  'imm0008.dependantTableDob': '出生日期（YYYY/MM/DD）',
  'imm0008.dependantTableStatus': '状态',
  'imm0008.dependantTableStatus.missingInformation': '缺少信息',
  'imm0008.dependantTableStatus.complete': '已完成',

  'imm0008.dependant.title': '被扶养人/家庭成员',
  'imm0008.dependant.description':
    '您必须提供每个家庭成员的以下信息，无论他们是否随同您前往加拿大。您必须包括您的配偶或同居伴侣（如果适用），以及您所有的被扶养子女，以及您的配偶或同居伴侣的被扶养子女，他们尚未成为加拿大永久居民或公民。',
  'imm0008.personalTitle': '个人信息',
  'imm0008.dependant.willAccompany': '此被扶养人是否随同主申请人前往加拿大？',
  'imm0008.dependant.relationshipToPrincipalApplicant':
    '与主申请人关系（例如配偶、同居伴侣、子女）',

  // 'imm0008.ifNotChina': '如果不是住在中国，请填写',
  // 'imm0008.fromDate': '从（年/月/日）',
  // 'imm0008.toDate': '至（年/月/日）',
  // 'imm0008.idFromDate': '开始日期（年/月/日）',
  // 'imm0008.idToDate': '结束日期（年/月/日）',

  'imm0008.steps.app': '申请详情',
  'imm0008.steps.personal': '个人信息',
  //'imm0008.steps.contact': '联系方式',
  'imm0008.steps.passport': '护照',
  'imm0008.steps.id': '身份证',
  'imm0008.steps.career': '教育/职业详情',
  'imm0008.steps.language': '语言能力',
  'imm0008.steps.dependant': '家庭成员',
};
